// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Tasks/Categories/index.css
// module id = 3056
// module chunks = 0